import React from 'react';

import { InstructionFlowStep } from '@components/utilities/Bookings/InstructionFlowStep';

export interface InstructionFlowState {
  completeSteps: string[];
  hiddenSteps: string[];
}

export interface InstructionFlowStepOption {
  name: string;
  title: string;
  steps?: string[];
}

export interface InstructionFlowProps {
  steps: InstructionFlowStepOption[];
  state: InstructionFlowState;
  formSubmitted: boolean;
}

export const InstructionFlow: React.FC<InstructionFlowProps> = (props) => {
  const { steps, state, formSubmitted } = props;

  const getStepStatus = (
    step: InstructionFlowStepOption,
    i: number,
  ): 'finished' | 'current' | 'future' => {
    if (state.completeSteps.some((s) => s === step.name)) {
      return 'finished';
    } else if (
      steps.some(
        (s, j) =>
          j < i && !state.hiddenSteps.includes(s.name) && !state.completeSteps.includes(s.name),
      )
    ) {
      // If it is invalid, but there is something earlier not finished,
      // user is not expected to enter it right away.
      return 'future';
    } else {
      return 'current';
    }
  };

  return (
    <div>
      {steps
        .filter((s) => !state.hiddenSteps.includes(s.name))
        .map((step, i) => (
          <InstructionFlowStep
            index={i + 1}
            key={i}
            status={getStepStatus(step, i)}
            title={step.title}
            steps={step.steps ?? []}
            formSubmitted={formSubmitted}
          />
        ))}
    </div>
  );
};
